import { Vue, Component } from 'vue-property-decorator';

@Component
export default class UserFormValidator extends Vue {
  private emailRegex: RegExp = new RegExp(
    /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
  );
  $sanitize: any;

  formValidator(form) {
    if (form.firstName) {
      form.firstName = form.firstName.trim();
    }
    if (form.lastName) {
      form.lastName = form.lastName.trim();
    }
    if (form.email) {
      form.email = form.email.trim();
    }
    if (!form.firstName) {
      return this.$t('referafriend.firstname.required');
    }
    if (!form.lastName) {
      return this.$t('referafriend.lastname.required');
    }
    if (!form.email) {
      return this.$t('referafriend.email.required');
    }
    if (!form.email) {
      return this.$t('referafriend.email.required');
    }

    if (!this.emailRegex.test(form.email)) {
      return this.$t('referafriend.enter.valid.email');
    }

    // if (!form.phoneNumber) {
    //   return this.$t('referafriend.phone.required');
    // }
    if (form.mobile!=null  && form.phoneNumber.length>0 && !form.phoneNumberValid) {
      return this.$t('referafriend.phone.valid');
    }
    return '';
  }

  internalReferralFormValidator(form) {
    if (!form.firstName) {
      return this.$t('referafriend.firstname.required');
    }
    if (!form.lastName) {
      return this.$t('referafriend.lastname.required');
    }
    if (!form.email) {
      return this.$t('referafriend.email.required');
    }
    if (!form.email) {
      return this.$t('referafriend.email.required');
    }

    if (!this.emailRegex.test(form.email)) {
      return this.$t('referafriend.enter.valid.email');
    }

    // if (!form.phoneNumber) {
    //   return this.$t('referafriend.phone.required');
    // }
    if (form.mobile!=null  &&form.phoneNumber.length>0 &&  !form.phoneNumberValid) {
      return this.$t('referafriend.phone.valid');
    }
    if (form.specialityIds[0] === 99) {
      return this.$t('referafriend.role.valid');
    }
    return '';
  }
}
